import React from 'react';
import { BasicField, CharacterCount } from '@am/multi_step_forms/basicFields';
import { validateFascinatingFindsField } from '../validation';

const MAX_IMAGES = 5;

export default function FascinatingFindsFieldRenderer({ fieldId, fields, values, filesState, errors, onFieldChange, onFilesChange, onRemovePhoto, onUpdatePhotoMetadata, consent }) {
	const config = fields[fieldId] || {};
	if (fieldId === 'consent_permission') {
		return (
			<div className="wizard-consent-step">
				<h2 className="wizard-consent-heading">
					{(consent && consent.permission_heading) || 'Before you begin, please confirm:'}
				</h2>
				{renderConsentCheckbox('consent_permission', consent.permission_copy, values, onFieldChange, true)}
				{renderConsentError(fieldId, errors)}
			</div>
		);
	}
	if (fieldId === 'consent_terms_of_use') {
		return (
			<div className="wizard-consent-step">
				{renderConsentCheckbox('consent_terms_of_use', consent.terms_of_use_copy, values, onFieldChange, true)}
				{renderConsentError(fieldId, errors)}
			</div>
		);
	}
	if (fieldId === 'obj_type_other' && values.obj_type !== 'Other') return null;
	if (fieldId === 'obj_fragile_note' && values.obj_fragile !== 'Yes') return null;
	if (fieldId === 'photos') {
		const photoCount = (filesState.photos || []).length;
		return (
			<div className="wizard-field wizard-photos-field">
				<label htmlFor="ff-photos">{config.label || 'Upload photos of the object.'}</label>
				{config.help_text && <div className="wizard-help-text">{config.help_text}</div>}
				{photoCount >= MAX_IMAGES && (
					<div className="wizard-help-text">
						You've added the maximum of {MAX_IMAGES} images.
					</div>
				)}
				{photoCount < 3 && <div className="wizard-help-text">You must provide at least 3 images.</div>}
				<input
					id="ff-photos"
					type="file"
					multiple
					accept="image/*"
					disabled={photoCount >= MAX_IMAGES}
					onChange={(event) => {
						onFilesChange(event.target.files);
						event.target.value = '';
					}}
				/>
				{errors[fieldId] && <div className="wizard-error">{errors[fieldId]}</div>}
				<ul className="wizard-photo-list">
					{(filesState.photos || []).map((item, index) => (
						<li key={`${item.file.name}-${index}`}>
							<img src={item.previewUrl} alt="" />
							<span>{item.file.name}</span>
							<input
								type="text"
								value={item.copyrightText || ''}
								placeholder="Copyright text (required)"
								aria-label={`Copyright text for photo ${index + 1}`}
								onChange={(e) => onUpdatePhotoMetadata(index, 'copyrightText', e.target.value)}
							/>
							<input
								type="text"
								value={item.photographer || ''}
								placeholder="Photographer (required)"
								aria-label={`Photographer for photo ${index + 1}`}
								onChange={(e) => onUpdatePhotoMetadata(index, 'photographer', e.target.value)}
							/>
							<button
								type="button"
								aria-label={`Remove photo ${index + 1}`}
								onClick={() => onRemovePhoto(index)}
							>
								<i className="fa fa-trash" aria-hidden="true" />
							</button>
						</li>
					))}
				</ul>
			</div>
		);
	}
	const inlineError = getInlineError(fieldId, config, values, filesState, errors);
	return (
		<div className={`wizard-field wizard-field-${fieldId}`}>
			{config.type !== 'checkbox-single' && <label htmlFor={`field-${fieldId}`}>{config.label || fieldId}</label>}
			{config.help_text && <div className="wizard-help-text">{config.help_text}</div>}
			<BasicField fieldId={fieldId} config={config} value={values[fieldId]} onChange={onFieldChange} />
			{(inlineError || config.max_length) && (
				<div className="wizard-field-messaging">
					{inlineError && <div className="wizard-error">{inlineError}</div>}
					<CharacterCount value={values[fieldId]} maxLength={config.max_length} />
				</div>
			)}
		</div>
	);
}

function getInlineError(fieldId, config, values, filesState, errors) {
	const serverError = errors[fieldId];
	if (serverError) return Array.isArray(serverError) ? serverError.join(' ') : serverError;
	const value = values[fieldId];
	if (!value) return null;
	return validateFascinatingFindsField(fieldId, config, value, values, filesState);
}

function renderConsentCheckbox(fieldId, label, values, onFieldChange, required) {
	return (
		<label className="wizard-consent-choice" htmlFor={`ff-${fieldId}`}>
			<input
				id={`ff-${fieldId}`}
				type="checkbox"
				checked={Boolean(values[fieldId])}
				required={required}
				onChange={(event) => onFieldChange(fieldId, event.target.checked)}
			/>
			<span dangerouslySetInnerHTML={{ __html: label }} />
		</label>
	);
}

function renderConsentError(fieldId, errors) {
	const serverError = errors ? errors[fieldId] : null;
	if (!serverError) return null;
	const message = Array.isArray(serverError) ? serverError.join(' ') : serverError;
	return <div className="wizard-error">{message}</div>;
}
